import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { makeGetTaskSubtasksCount, makeGetTaskCompletedSubtasksCount } from '../selectors/tasks';

import ProgressBar from './progress-bar';

class SubtasksOverview extends PureComponent {
    render() {
        const subtasksProgress = Math.round(this.props.completedSubtasksCount / this.props.subtasksCount * 100);

        return (
            <div className="progress-wrapper">
                <span className="progress-count">{this.props.completedSubtasksCount} / {this.props.subtasksCount}</span>

                <ProgressBar showProgress={false} progress={subtasksProgress} />
            </div>
        );
    }
};

const makeMapStateToProps = () => {
    const getTaskSubtasksCount = makeGetTaskSubtasksCount();
    const getTaskCompletedSubtasksCount = makeGetTaskCompletedSubtasksCount();

    return ({ tasks }, ownProps) => ({
        subtasksCount: getTaskSubtasksCount(tasks.items, ownProps.taskId),
        completedSubtasksCount: getTaskCompletedSubtasksCount(tasks.items, ownProps.taskId)
    });
};

export default connect(makeMapStateToProps)(SubtasksOverview);
